<div class="modal-overlay" id="modal" [ngClass]="{hidden: !modal.isModalOpen(modalId)}">
    <div class="modal-section">
        <div class="modal-header">
            <ng-content select="[heading]"></ng-content>
            <div class="modal-close" (click)="closeModal()">&#x2715;</div>
        </div>
        <ng-content></ng-content>
    </div>
</div>